<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddNewDeviceScanQR-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddNewDeviceScanQR-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <div class="lxn-w100 lxn-h100">
            <div class="AddNewDeviceScanQR-d0 lxn-w100 lxn-h100 lxn-pos-rel">
              <svg viewBox="0 0 113.4 113.4">
                <path class="AddNewDeviceScanQR-st0" d="M92.7,0h-72C9.3,0,0,9.3,0,20.7v72c0,11.4,9.3,20.7,20.7,20.7h72c11.4,0,20.7-9.3,20.7-20.7v-72C113.4,9.3,104.1,0,92.7,0z M102.1,97.6c0,2.5-2,4.5-4.5,4.5c0,0-15.7,2.9-40.9,2.9s-40.9-2.9-40.9-2.9c-2.5,0-4.5-2-4.5-4.5c0,0-2.9-15.7-2.9-40.9c0-25.2,2.9-40.9,2.9-40.9c0-2.5,2-4.5,4.5-4.5c0,0,15.7-2.9,40.9-2.9s40.9,2.9,40.9,2.9c2.5,0,4.4,2,4.4,4.5c0,0,2.9,15.7,2.9,40.9C104.9,81.9,102.1,97.6,102.1,97.6z"/>
              </svg>
            </div>
            <div v-if="appMode != 'phonegap'" class="AddNewDeviceScanQR-d1 lxn-pos-rel lxn-margin-auto">
              <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit" :track="paintBlueDots">
                <div v-if="loading || pending" :class="[$store.getters.language.font, $store.getters.language.directionClass]" class="AddNewDeviceScanQR-loading lxn-title lxn-text-center lxn-w100 lxn-h100">
                  {{$store.getters.language.texts.AddNewDeviceScanQR_loading}}
                </div>
                <div v-if="error" :class="[$store.getters.language.font, $store.getters.language.directionClass]" class="AddNewDeviceScanQR-error lxn-text lxn-text-center lxn-w100 lxn-h100">
                  {{errorText}}
                </div>
              </qrcode-stream>
            </div>
          </div>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.AddNewDeviceScanQR_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.AddNewDeviceScanQR_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import * as CONFIGS from '@/statics/configs.js'
import Logger from '@/statics/logger.js'
import Messaging from '@/statics/messaging.js'
import { QrcodeStream } from 'vue-qrcode-reader'

var messaging = new Messaging(new Logger(false));


export default {
  name: 'AddNewDeviceScanQR',
  components: {
    QrcodeStream,
    CustomCurve,
    TopNav,
    WrapperSvgTitleText,
  },
  data: function () {
    return {
      camera: 'auto',
      loading: false,
      pending: false,
      scannedQR: null,
      errorText: '',
      error: false
    }
  },
  mounted: function () {
      
      
      if(CONFIGS.APP_MODE == 'phonegap'){        
        // eslint-disable-next-line no-undef
        const permissions = cordova.plugins.permissions;
        permissions.hasPermission(() => {return}, permissions.requestPermission(permissions.camera, () => {return}, () => {return}), permissions.camera);
        // eslint-disable-next-line no-undef
        cordova.plugins.barcodeScanner.scan(function (result)
            {
                if(!result.cancelled) {
                    var qrValidateResult = this.validateQR(result.text);
                    console.log(qrValidateResult)
                    if( qrValidateResult.satuts ){
                      if( (this.$store.getters.getNodeByUUID(qrValidateResult.qrData.uuid) !== -1) || (this.$store.getters.getHubByUUID(qrValidateResult.qrData.uuid) !== -1)){
                        this.$router.push('/AddNewDeviceDuplicated');
                      }else{
                        this.$store.commit('setScannedQR', qrValidateResult.qrData);
                        if(qrValidateResult.qrData.deviceType == 1){
                          this.$router.push('/addHub');
                        }else if(qrValidateResult.qrData.deviceType == 12){
                          this.$router.push('/AddRGBStandAlone');
                        }else{
                          if(this.$store.state.hubs.length == 0){
                            this.$router.push('/AddNewDeviceNoHub');
                          }else{
                            this.$router.push('/addNode-' + qrValidateResult.qrData.deviceType);
                          }
                        }
                      }
                    }else{
                      alert(this.$store.getters.language.texts.AddNewDeviceScanQR_error);
                      this.$router.push("/AddNewDevice");
                    }
                }else{
                  //QR scan in cancelled by user.
                  this.$router.push("/AddNewDevice");
                }
            }.bind(this)
            ,function ()
            {
              alert(this.$store.getters.language.texts.AddNewDeviceScanQR_error);
              this.$router.push("/AddNewDevice");
            }.bind(this)
        );
      }
  },
  computed: {
    appMode: function () {
      return CONFIGS.APP_MODE;
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    async onDecode (scannedQR) {
      this.error = false;
      this.pending = true;
      this.scannedQR = scannedQR

      this.turnCameraOff()
      this.pending = false;
      var qrValidateResult = this.validateQR(scannedQR);
      if( qrValidateResult.satuts ){
        await this.timeout(1000);
        if( (this.$store.getters.getNodeByUUID(qrValidateResult.qrData.uuid) !== -1) || (this.$store.getters.getHubByUUID(qrValidateResult.qrData.uuid) !== -1)){
          this.$router.push('/AddNewDeviceDuplicated');
        }else{
          this.$store.commit('setScannedQR', qrValidateResult.qrData);
          if(qrValidateResult.qrData.deviceType == 1){
            this.$router.push('/addHub');
          }else if(qrValidateResult.qrData.deviceType == 12){
            this.$router.push('/AddRGBStandAlone');
          }else{
            if(this.$store.state.hubs.length == 0){
              this.$router.push('/AddNewDeviceNoHub');
            }else{
              this.$router.push('/addNode-' + qrValidateResult.qrData.deviceType);
            }
          }
        }
      }else{
        this.error = true;
        this.errorText = this.$store.getters.language.texts.AddNewDeviceScanQR_error;
        await this.timeout(2000)
        this.error = false;
        this.turnCameraOn()
      }
    },
    turnCameraOff () {
      this.camera = 'off'
    },
    turnCameraOn () {
      this.camera = 'auto'
    },
    paintBlueDots: function (location, ctx) {
      const {
        topLeftFinderPattern,
        topRightFinderPattern,
        bottomLeftFinderPattern
      } = location
      const pointArray = [
        topLeftFinderPattern,
        topRightFinderPattern,
        bottomLeftFinderPattern
      ]

      ctx.fillStyle = 'rgba(30, 165, 222, 0.5)'

      pointArray.forEach(({ x, y }) => {
        ctx.fillRect(x - 5, y - 5, 10, 10)
      })
    },
    async onInit (promise) {
      this.loading = true

      try {
        await promise
      } catch (error) {
        this.error = true;
        if (error.name === 'NotAllowedError') {
          // user denied camera access permisson
          this.errorText = this.$store.getters.language.texts.AddNewDeviceScanQR_NotAllowedError;
        } else if (error.name === 'NotFoundError') {
          // no suitable camera device installed
          this.errorText = this.$store.getters.language.texts.AddNewDeviceScanQR_NotFoundError;
        } else if (error.name === 'NotSupportedError') {
          // page is not served over HTTPS (or localhost)
          this.errorText = this.$store.getters.language.texts.AddNewDeviceScanQR_NotSupportedError;
        } else if (error.name === 'NotReadableError') {
          // maybe camera is already in use
          this.errorText = this.$store.getters.language.texts.AddNewDeviceScanQR_NotReadableError;
        } else if (error.name === 'OverconstrainedError') {
          // did you requested the front camera although there is none?
          this.errorText = this.$store.getters.language.texts.AddNewDeviceScanQR_OverconstrainedError;
        } else if (error.name === 'StreamApiNotSupportedError') {
          // browser seems to be lacking features
          this.errorText = this.$store.getters.language.texts.AddNewDeviceScanQR_StreamApiNotSupportedError;
        }
      } finally {
        this.loading = false
      }
    },
    timeout (ms) {
      return new Promise(resolve => {
        window.setTimeout(resolve, ms)
      })
    },
    validateQR: function (scannedQR) {
      try {
        var extractedScannedQRArray = new Uint8Array(atob(scannedQR).split("").map(function(c)
        {
            return c.charCodeAt(0); 
        }));
        if(extractedScannedQRArray.length != 39){
          return {status: false};
        }else{
          var fallback = [];
          for(var i = 7; i < extractedScannedQRArray.length; i++){
            fallback.push(extractedScannedQRArray[i]);
          }
          var uuid = messaging.utility.littleEndianUint8ToUint32(extractedScannedQRArray);
          var extractedScannedQR = {
            deviceType: extractedScannedQRArray[4],
            //used >>>0 to convert signed int to unsigned int
            uuid: uuid >>> 0,
            fallback: fallback,
            firmwareYear: extractedScannedQRArray[5],
            firmwareMonth: extractedScannedQRArray[6]
          };
          return {satuts: true, qrData: extractedScannedQR};
        }
      } catch (error) {
        return {status: false};
      }
    },
  }
}
</script>

<style>
  .AddNewDeviceScanQR-topCurve-wrapper {
    height: 200px;
  }
  .AddNewDeviceScanQR-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .AddNewDeviceScanQR-d0 {
    left: 0;
    top: 0;
    z-index: 3;
  }
  .AddNewDeviceScanQR-d1 {
    left: 0;
    top: -100%;
    z-index: 2;
    width: 86%;
    height: 86%;
    margin-top: 7%;
  }
  .AddNewDeviceScanQR-loading {
    padding-top: calc(50% - 10px);
    line-height: 20px;
    color: #1EA5DE;
    background-color: rgba(255, 255, 255, 0.8);
  }
  .AddNewDeviceScanQR-error {
    padding-top: calc(50% - 10px);
    line-height: 20px;
    color: #F36C4F;
    background-color: rgba(255, 240, 240, 0.8);
  }
	.AddNewDeviceScanQR-st0 {
    fill: #CECECE;
  }
</style>
